module.exports = __webpack_public_path__ + "img/06.da14aafa.jpg";